import { render, staticRenderFns } from "./pc-input-text.vue?vue&type=template&id=e60f7380&scoped=true&"
import script from "./pc-input-text.vue?vue&type=script&lang=ts&"
export * from "./pc-input-text.vue?vue&type=script&lang=ts&"
import style0 from "./pc-input-text.vue?vue&type=style&index=0&id=e60f7380&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60f7380",
  null
  
)

export default component.exports